import React, { ReactNode } from 'react';

const TableHeader = ({
  children,
  style,
}: {
  children?: ReactNode;
  style?: any;
}): JSX.Element => {
  return (
    <th
      style={{
        paddingLeft: '1rem',
        paddingRight: '1rem',
        ...style,
      }}
    >
      {children}
    </th>
  );
};

export default TableHeader;
